module.exports = __webpack_public_path__ + "img/zx9.cc044a4d.png";